const QXDetails = () => import ('@/mobile/QXDetails.vue');
const DataType = () => import('@/mobile/DataType.vue');
const DataInfo = () => import('@/mobile/DataInfo.vue');
export default [
  {
    path: '/mobile/details/:gldId/:type/:tenantIds',
    name:'mobile/details',
    component: QXDetails,
    meta:{
      title:"祺信信息",
      public:true,
      keepAlive:true
    }
  },
  {
    path: '/mobile/dataType/:gldId',
    name:'mobile/dataType',
    component: DataType,
    meta:{
      title:"资料类型",
      public:true,
      keepAlive:true
    }
  },
  {
    path: '/mobile/dataInfo',
    name:'mobile/dataInfo',
    component: DataInfo,
    meta:{
      title:"资料编号",
      public:true,
      keepAlive:true
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/mobile.js